/* eslint jsx-a11y/no-noninteractive-tabindex: ["error", { "roles": ["region"] }] */
import React, { useEffect, useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import OpenInFull from "@mui/icons-material/OpenInFull";
import Close from "@mui/icons-material/Close";
import LockOutlined from "@mui/icons-material/LockOutlined";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import ArrowBack from "@mui/icons-material/ArrowBack";
import ZoomIn from "@mui/icons-material/ZoomIn";
import ZoomOut from "@mui/icons-material/ZoomOut";
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";
import AppIcon from "./DemoAppIcon";
import DemoExecutionFrame from "./DemoExecutionFrame";
import GrowthWorkScenes from "./GrowthWorkScenes";
import CompanyGrowthScenes from "./CompanyGrowthScenes";
import { DEMO_APPS } from "../data/product-demo";
import "../styles/work-screen.css";
import "../styles/growth-work-scenes.css";
import "../styles/company-growth-scenes.css";

function AppScene({ mission, app, stage }) {
  const detail = mission.stageDetails?.[stage] || {};
  const rows = detail.rows || mission.rows;
  const columns = detail.columns || mission.columns;
  if (["posthog", "googleads", "mailchimp"].includes(app))
    return <CompanyGrowthScenes mission={mission} app={app} stage={stage} />;
  if (["gmail", "linkedin", "hubspot", "googlecalendar"].includes(app))
    return <GrowthWorkScenes mission={mission} app={app} />;
  if (app === "linear")
    return (
      <div className="work-linear">
        <aside>
          <strong>Northstar</strong>
          <span>My issues</span>
          <span>
            Inbox <small>4</small>
          </span>
          <span className="work-side-label">Workspace</span>
          <span>Projects</span>
          <span className="active">Customer portal</span>
          <span>Roadmap</span>
          <span className="work-side-label">Your teams</span>
          <span>Product</span>
          <span>Engineering</span>
        </aside>
        <section>
          <div className="work-app-breadcrumb">Projects / Customer portal</div>
          <h4>
            Customer portal <span>In progress</span>
          </h4>
          <p>Product launch / September release</p>
          <div className="work-board">
            {[
              [
                "In progress",
                [
                  ["ENG-142", "Verify release monitors", "James"],
                  ["PRD-089", "Finalize rollout plan", "Erin"],
                ],
              ],
              [
                "In review",
                [
                  ["ENG-138", "Accessibility verification", "James"],
                  ["CX-024", "First-run walkthrough", "Regina"],
                ],
              ],
              [
                "Done",
                [
                  ["ENG-131", "Workspace permissions", "James"],
                  ["CX-021", "Onboarding guide", "Regina"],
                ],
              ],
            ].map(([title, items], i) => (
              <div key={title}>
                <div className="work-board-label">
                  <i
                    style={{ background: ["#e5a62c", "#5e6ad2", "#748894"][i] }}
                  />
                  {title}
                  <span>2</span>
                </div>
                {items.map(([id, title, owner]) => (
                  <article key={id}>
                    <small>{id}</small>
                    <strong>{title}</strong>
                    <footer>
                      <span>{i === 2 ? "Complete" : "Portal v2.4"}</span>
                      <b>{owner[0]}</b>
                    </footer>
                  </article>
                ))}
              </div>
            ))}
          </div>
        </section>
      </div>
    );
  if (app === "github")
    return (
      <div className="work-github">
        <div className="work-app-breadcrumb">
          <AppIcon id="github" />
          northstar / <strong>customer-portal</strong>
          <span>Private</span>
        </div>
        <div className="work-repo-tabs">
          Code <b>Pull requests</b> Actions Projects Security
        </div>
        <section>
          <span className="work-pr-tag">Merged</span>
          <h4>
            Improve portal accessibility <small>#142</small>
          </h4>
          <p>
            james-agent merged 3 commits into <code>main</code>
          </p>
          <div className="work-check-summary">
            <CheckCircleOutline />
            <div>
              <strong>All checks have passed</strong>
              <span>
                4 successful checks / verified against the release build
              </span>
            </div>
          </div>
          {[
            "Build / production",
            "Test / keyboard navigation",
            "Test / screen reader",
            "Deploy / preview",
          ].map((check, i) => (
            <div className="work-check-row" key={check}>
              <CheckCircleOutline />
              <strong>{check}</strong>
              <span>{[42, 18, 24, 31][i]}s</span>
              <small>Successful</small>
            </div>
          ))}
          <footer>
            3 files changed <span>+48</span> <span>-12</span>
            <small>Reviewed by erin-agent</small>
          </footer>
        </section>
      </div>
    );
  if (app === "intercom")
    return (
      <div className="work-intercom">
        <aside>
          <AppIcon id="intercom" />
          <strong>Inbox</strong>
          <span className="active">
            Your inbox <b>6</b>
          </span>
          <span>
            Unassigned <b>2</b>
          </span>
          <span>All conversations</span>
          <span className="work-side-label">Teams</span>
          <span>Customer success</span>
          <span>Onboarding</span>
        </aside>
        <div className="work-inbox-list">
          <h4>
            Onboarding <small>6</small>
          </h4>
          {[
            ["Alex / Northstar", "The import is working now. Thank you!"],
            ["Mia / Meridian", "Connecting our workspace"],
            ["Kai / Common Ground", "First workflow completed"],
            ["Avery / Forma", "Setting up the team"],
          ].map(([name, msg], i) => (
            <div className={i === 0 ? "selected" : ""} key={name}>
              <strong>{name}</strong>
              <time>{i + 2}m</time>
              <p>{msg}</p>
              <small>{i === 0 ? "Resolved" : "Onboarding"}</small>
            </div>
          ))}
        </div>
        <section>
          <header>
            <strong>Alex Morgan</strong>
            <small>Northstar / Customer onboarding</small>
          </header>
          <div className="work-chat-date">Today, 10:08</div>
          <div className="work-chat-bubble">
            The import is working now. All of our customer records are here.
          </div>
          <div className="work-chat-bubble outgoing">
            I&apos;ve verified the import and connected your first workflow.
            Your workspace is ready, Alex.
          </div>
          <div className="work-chat-note">
            <CheckCircleOutline /> First-value milestone verified
          </div>
          <div className="work-chat-bubble">
            Perfect. We&apos;re up and running.
          </div>
          <footer>
            <span>Resolved by Regina</span>
            <small>Success handoff attached</small>
          </footer>
        </section>
      </div>
    );
  if (app === "googlesheets")
    return (
      <div className="work-sheets">
        <header>
          <AppIcon id="googlesheets" />
          <div>
            <h4>
              {detail.sheetTitle || mission.sheetTitle || mission.document}
            </h4>
            <span>File Edit View Insert Format Data Tools</span>
          </div>
          <b>Share</b>
        </header>
        <div className="work-sheet-tools">
          100% <span>Arial</span> 10 <b>B</b> <i>I</i>
          <span> A </span>
          <span>Σ</span>
        </div>
        <div className="work-formula">
          <span>B4</span>
          <i>fx</i> {rows[2][1]}
        </div>
        <div className="work-sheet-grid">
          <div className="work-sheet-letters">
            <span />
            <span>A</span>
            <span>B</span>
            <span>C</span>
            <span>D</span>
          </div>
          <div className="work-sheet-row heading">
            <small>1</small>
            {columns.map((x) => (
              <span key={x}>{x}</span>
            ))}
          </div>
          {rows.map((row, i) => (
            <div className="work-sheet-row" key={row[0]}>
              <small>{i + 2}</small>
              {row.map((cell, j) => (
                <span
                  className={i === 2 && j === 1 ? "active-cell" : ""}
                  key={j}
                >
                  {cell}
                </span>
              ))}
            </div>
          ))}
          {[7, 8, 9, 10].map((n) => (
            <div className="work-sheet-row empty" key={n}>
              <small>{n}</small>
              <span />
              <span />
              <span />
              <span />
            </div>
          ))}
        </div>
        <footer>
          <span>Overview</span>
          <span>Evidence</span>
          <span>Activity log</span>
          <small>All changes saved</small>
        </footer>
      </div>
    );
  if (app === "googledrive")
    return (
      <div className="work-drive">
        <aside>
          <div>
            <AppIcon id="googledrive" />
            <strong>Drive</strong>
          </div>
          <span>Home</span>
          <span>My Drive</span>
          <span className="active">Shared drives</span>
          <span>Recent</span>
          <span>Starred</span>
        </aside>
        <section>
          <div className="work-drive-search">Search in Drive</div>
          <h4>
            Northstar <span>/</span> {mission.short}
          </h4>
          <div className="work-drive-table">
            <header>
              <span>Name</span>
              <span>Owner</span>
              <span>Modified</span>
            </header>
            {(
              mission.evidenceFiles || [
                mission.document,
                ...mission.rows.slice(0, 4).map((r) => r[0]),
              ]
            ).map((name, i) => (
              <div key={name}>
                <InsertDriveFileOutlined />
                <strong>{name}</strong>
                <span>{["Erin", "Simon", "James", "Regina"][i % 4]}</span>
                <time>Today, 09:{12 + i * 5}</time>
              </div>
            ))}
          </div>
          <p>Shared with the mission team</p>
        </section>
      </div>
    );
  return (
    <div className="work-notion">
      <aside>
        <strong>
          <AppIcon id="notion" />
          Northstar
        </strong>
        <span>Search</span>
        <span>Home</span>
        <span className="work-side-label">Teamspaces</span>
        <span>Company</span>
        <span className="active">{mission.short}</span>
        <span>Shared knowledge</span>
        <span className="work-side-label">Private</span>
        <span>Mission notes</span>
      </aside>
      <section>
        <div className="work-app-breadcrumb">
          {mission.short} / {detail.title || mission.document}
          <span>Edited just now</span>
        </div>
        <article>
          <InsertDriveFileOutlined />
          <h4>{detail.title || mission.document}</h4>
          <div className="work-document-meta">
            <span>Status</span>
            <strong>{detail.status || "In progress"}</strong>
            <span>Owner</span>
            <strong>
              {["marketing", "customers"].includes(mission.id)
                ? "Regina"
                : "Erin Reyes"}
            </strong>
          </div>
          <h5>
            {detail.heading ||
              (mission.id === "market"
                ? "The opportunity"
                : mission.id === "customers"
                  ? "First value, for every customer"
                  : "A clear path to the outcome")}
          </h5>
          <p>{detail.summary || mission.summary}</p>
          <div className="work-document-note">
            {detail.note || mission.destination}
          </div>
          <h5>
            {stage === mission.steps.length - 1 ? "Next actions" : "The plan"}
          </h5>
          {(detail.items || mission.activity.slice(0, 3)).map((x) => (
            <div className="work-document-check" key={x}>
              <RadioButtonUnchecked />
              {x}
            </div>
          ))}
        </article>
      </section>
    </div>
  );
}

function BrowserView({
  mission,
  app,
  stage,
  setApp,
  nativeSize = false,
  onInteraction,
}) {
  const container = useRef(null);
  const tabs = useRef(null);
  const [width, setWidth] = useState(800);
  useEffect(() => {
    const strip = tabs.current;
    const active = strip?.querySelector('[aria-pressed="true"]');
    if (!active) return;
    const edge = strip.getBoundingClientRect();
    const item = active.getBoundingClientRect();
    if (item.left < edge.left) strip.scrollLeft += item.left - edge.left;
    else if (item.right > edge.right)
      strip.scrollLeft += item.right - edge.right;
  }, [app]);
  useEffect(() => {
    const observer = new ResizeObserver(([entry]) =>
      setWidth(entry.contentRect.width),
    );
    if (container.current) observer.observe(container.current);
    return () => observer.disconnect();
  }, []);
  const scale = nativeSize ? 1 : Math.min(width / 800, 1.5);
  return (
    <div
      className="work-browser"
      ref={container}
      onClickCapture={onInteraction}
    >
      <div
        className="work-browser-tabs"
        ref={tabs}
        role="group"
        aria-label="Computer view app"
      >
        {mission.apps.map((id) => (
          <button key={id} aria-pressed={id === app} onClick={() => setApp(id)}>
            <AppIcon id={id} />
            {DEMO_APPS[id].name}
          </button>
        ))}
      </div>
      <div className="work-address">
        <ArrowBack />
        <span>
          <LockOutlined />
          {DEMO_APPS[app].domain}
          <small>
            /
            {app === "linkedin"
              ? mission.id === "hiring"
                ? "talent / projects / founding-engineers"
                : "sales / lists / customer-operations"
              : DEMO_APPS[app].path}
          </small>
        </span>
        <i>Demo</i>
      </div>
      <div
        className="work-scene-scroll"
        role="region"
        tabIndex={nativeSize ? 0 : undefined}
        aria-label="Computer view screen"
      >
        <div
          className="work-scene-frame"
          style={{ height: 470 * scale, width: nativeSize ? 800 : "100%" }}
        >
          <div
            className="work-scene"
            style={{ transform: "scale(" + scale + ")" }}
          >
            <AppScene
              key={app + stage}
              mission={mission}
              app={app}
              stage={stage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function WorkScreen({
  mission,
  stage = mission.initialStage,
  mode = "supervised",
  onInteraction,
  onStageChange,
}) {
  const app = mission.appSequence[stage];
  const setApp = (nextApp) => {
    if (nextApp !== app) onStageChange(mission.appSequence.indexOf(nextApp));
  };
  const [expanded, setExpanded] = useState(false);
  const [nativeSize, setNativeSize] = useState(false);
  return (
    <>
      <DemoExecutionFrame
        mode={mode}
        label="Computer view"
        className="work-screen"
      >
        <div className="work-screen-toolbar">
          <span>Computer view</span>
          <small>
            {DEMO_APPS[app].name} / {mission.short}
          </small>
          <button
            onClick={() => {
              onInteraction?.();
              setExpanded(true);
            }}
            title="Enlarge computer view"
            aria-label="Enlarge computer view"
          >
            <OpenInFull />
          </button>
        </div>
        <BrowserView
          mission={mission}
          app={app}
          stage={stage}
          setApp={setApp}
          onInteraction={onInteraction}
        />
      </DemoExecutionFrame>
      <Dialog
        open={expanded}
        onClose={() => setExpanded(false)}
        maxWidth="lg"
        fullWidth
        aria-labelledby="computer-view-title"
        PaperProps={{
          sx: {
            borderRadius: "6px",
            margin: { xs: "12px", sm: "32px" },
            width: { xs: "calc(100% - 24px)", sm: "calc(100% - 64px)" },
          },
        }}
      >
        <DialogTitle
          id="computer-view-title"
          sx={{
            fontFamily: "Manrope, sans-serif",
            fontSize: 15,
            paddingRight: 12,
          }}
        >
          Computer view / {mission.short}
          <IconButton
            aria-label={
              nativeSize
                ? "Fit computer view"
                : "Show computer view at full size"
            }
            title={nativeSize ? "Fit to window" : "Full size"}
            onClick={() => setNativeSize(!nativeSize)}
            sx={{ position: "absolute", right: 52, top: 9 }}
          >
            {nativeSize ? <ZoomOut /> : <ZoomIn />}
          </IconButton>
          <IconButton
            aria-label="Close computer view"
            onClick={() => setExpanded(false)}
            sx={{ position: "absolute", right: 12, top: 9 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: "0 12px 12px" }}>
          {expanded && (
            <DemoExecutionFrame mode={mode} label="Expanded computer view">
              <BrowserView
                mission={mission}
                app={app}
                stage={stage}
                setApp={setApp}
                nativeSize={nativeSize}
                onInteraction={onInteraction}
              />
            </DemoExecutionFrame>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
